import { useState } from 'react';
import { Button, Stack, TextField } from '@mui/material';
import { parseAnywhereClientId } from '../../../service/anywhere';

export default function AnywhereAdminKnownClientEntry({ onConfirm }) {
  const [value, setValue] = useState('');
  const [hasError, setHasError] = useState(false);

  const handleConfirm = () => {
    const idClient = parseAnywhereClientId(value);
    if (idClient == null) {
      setHasError(true);
      return;
    }

    setHasError(false);
    onConfirm(idClient);
  };

  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} alignItems={{ sm: 'flex-start' }}>
      <TextField
        id="anywhere-admin-known-client"
        label="ID do cliente"
        type="number"
        value={value}
        onChange={(event) => {
          setValue(event.target.value);
          if (hasError) setHasError(false);
        }}
        error={hasError}
        helperText={hasError ? 'Informe um inteiro positivo.' : 'Use um ID de cliente conhecido.'}
        inputProps={{ inputMode: 'numeric', min: 1, step: 1 }}
        size="small"
      />
      <Button variant="contained" onClick={handleConfirm} sx={{ minHeight: 40 }}>
        Operar cliente
      </Button>
    </Stack>
  );
}
